export const APP_MESSAGES = {
    //user
    USER_CREATE_SUCCESS: 'New User Created.',
    USER_UPDATE_SUCCESS: 'User Updated.',

    //IE Distribution
    IE_DISTRIBUTION_CREATE_SUCCESS: 'New IE Distribution Created.',
    IE_DISTRIBUTION_UPDATE_SUCCESS: 'IE Distribution Updated.',
    IE_DISTRIBUTION_DELETE_SUCCESS: 'IE Distribution Deleted.',
    UPDATE_PER_WEEK_HOURS: 'Per Week Hours Updated.',

    // user roles
    USER_ROLE_UPDATE_SUCCESS: 'User Roles Updated.',

    // user factories
    USER_FACTORY_UPDATE_SUCCESS: 'User Factories Updated.',

    // factories
    FACTORY_CREATE_SUCCESS: 'New Factory Created.',
    FACTORY_UPDATE_SUCCESS: 'Factory Updated.',
}
